/**
 * 入庫狀態標籤（**單一位置**：狀態值 → 顏色 tone ＋ i18n key）
 * ⚠️ 狀態值係後端契約（`intake_batches.status`）—— 呢度**唔准**自己發明新值。
 */
import { useTranslation } from 'react-i18next';
import { badge } from '@coeldery/ui-kit';
import type { IntakeStatus } from '../lib/api';

const TONE: Record<IntakeStatus, 'ok' | 'off' | 'warn' | 'info'> = {
  declared: 'info',
  received: 'info',
  verified: 'ok',
  discrepancy: 'warn',
  cancelled: 'off',
};

const LABEL: Record<IntakeStatus, string> = {
  declared: 'intake.statusDeclared',
  received: 'intake.statusReceived',
  verified: 'intake.statusVerified',
  discrepancy: 'intake.statusDiscrepancy',
  cancelled: 'intake.statusCancelled',
};

/** 狀態 → i18n key（**單一來源**：篩選器／標籤都用呢個，唔准各自再抄一份） */
export const statusLabelKey = (status: IntakeStatus): string =>
  LABEL[status] ?? 'intake.statusDeclared';

export const INTAKE_STATUSES: IntakeStatus[] = [
  'declared',
  'verified',
  'discrepancy',
  'cancelled',
];

export default function IntakeStatusChip({ status }: { status: IntakeStatus }) {
  const { t } = useTranslation();
  return <span style={badge(TONE[status] ?? 'info')}>{t(statusLabelKey(status))}</span>;
}
